import ReactDOM from 'react-dom/client';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

const baseUrl = "/";
const root = ReactDOM.createRoot(document.getElementById('ticketinoShopPlugin'));


root.render(
    <BrowserRouter basename={baseUrl}>
        <App />
    </BrowserRouter>
);


